export default __webpack_public_path__ + "static/image20-8fac91bbf46f5ece7cb4d642807b9604.gif";